import { FormControl, Grid, IconButton, MenuItem, Select, TextField } from '@material-ui/core';
import MuiButton from 'components/common/button/MuiButton';
import CustomDatePicker from 'components/common/input/CustomDatePicker';
import MuiWrapper from 'components/common/input/MuiWrapper';
import { StyledPlainButtonOuter } from 'components/common/styled/Button';
import CustomSpan from 'components/common/text/CustomSpan';
import useDateInput from 'lib/hooks/useDateInput';
import useInput from 'lib/hooks/useInput';
import React, { Fragment, useEffect, useMemo, useRef, useState } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { color } from 'styles/utils';
import cx from 'classnames';
import PencilUnderlineIcon from 'components/base/icons/PencilUnderlineIcon';
import TrashIcon from 'components/base/icons/TrashIcon';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import { useDidUpdateEffect } from 'lib/utils';
import { addCommas, validateObjProperties } from 'lib/library';
import CustomText from 'components/common/text/CustomText';
import moment from 'moment';
import useCheckSetInput from 'lib/hooks/useCheckSetInput';
import { AppActions, InvoiceActions, PartnerActions } from 'store/actionCreators';
import { fetch_sync_partners } from 'store/modules/partner';
import AsyncFetchSelect from 'components/common/select/AsyncFetchSelect';
import { fetchSyncPartners } from 'api/partner';
import { debounce } from 'lodash';
import { useShallowAppSelector } from 'store/hooks';
import { PermIdentityOutlined } from '@material-ui/icons';
import { IPartnerInfo } from 'lib/types/invoiceTypes';
import PlainModal from 'components/common/modal/PlainModal';
import AppModal from 'components/common/modal/AppModal';
import CompleteProjectModalContainer from 'containers/project/CompleteProjectModalContainer';
import { ICurrency } from 'lib/types/sharedTypes';
import { IProjectInvoiceInfo } from 'lib/types/projectTypes';
import { icon_modify } from 'components/base/images';
import T from 'components/common/text/T';
import { useTranslation } from 'react-i18next';
import useFetchLoading from 'lib/hooks/useFetchLoading';
import ListEmpty from 'components/common/list/ListEmpty';
import CircularLoading from 'components/base/loading/CircularLoading';

interface CreateInvoiceModalContainerProps {
  requestFetchInvoicePartners: (value: {
    keyword?: string;
    page?: number;
    setLoading?: (value: boolean) => {};
  }) => any;
  onClose: () => void;
}

interface InvoicePartnersData {
  list?: {
    email: string;
    groupCode: string;
    isSelf: number;
    name: string;
    partnerType: null | number;
    userGroupIdx: number;
  }[];
  pagingData?: {
    endPage: number;
    nextPage: number;
    page: number;
    prevPage: number;
    startPage: number;
    totalPage: number;
  };
}

interface InvoicePartner {
  email: string;
  groupCode: string;
  isSelf: number;
  name: string;
  partnerType: null | number;
  userGroupIdx: number;
}

interface InvoicePagingData {
  endPage: number;
  nextPage: number;
  page: number;
  prevPage: number;
  startPage: number;
  totalPage: number;
}

interface Unit {
  // [key: string]: string | number;
  content: string;
  quantity: number;
  unitPrice: number;
  //
  isModify?: boolean;
}

interface ProjectInvoice {
  projectCode: string;
  projectIdx: number;
  projectId: string;
  unitList: Unit[];
  currency: string;
  invoiceInfo: IProjectInvoiceInfo;
}

// interface ProjectListItem {
//   completeDate: number;
//   projectCode: string;
//   projectId: string;
//   projectIdx: number;
//   unitList: { content: string; quantity: number; projectIdx: number;, unitPrice: number; }[];
// }

function CreateInvoiceModalContainer({
  requestFetchInvoicePartners,
  onClose,
}: CreateInvoiceModalContainerProps) {
  const {
    language,
    invoiceInitData,
    invoiceInitDataSuccess,
    invoiceInitDataPending,
    invoiceInitDataFailure,
    createInvoiceSuccess,
    fetchCurrencyList: { currencyList },
  } = useShallowAppSelector(state => ({
    language: state.base.language,
    invoiceInitData: state.invoice.invoiceTotalInit.data || {},
    invoiceInitDataSuccess: state.invoice.invoiceTotalInit.success,
    invoiceInitDataPending: state.invoice.invoiceTotalInit.pending,
    invoiceInitDataFailure: state.invoice.invoiceTotalInit.failure,
    createInvoiceSuccess: state.invoice.createInvoice.success,
    fetchCurrencyList: state.util.currencyList.data || {},
  }));
  const [isLoadSuccess, setIsLoadSuccess] = useState<boolean>(false);
  const [isLoadFailure, setIsLoadFailure] = useState<boolean>(false);
  const partnerInfo: IPartnerInfo = invoiceInitData?.partnershipInfo;
  const projectList = invoiceInitData?.projectList;
  const invoiceCurrencyList = invoiceInitData?.currencyList;

  const period = useDateInput(null);

  const { t } = useTranslation();
  const currency = useInput('');
  const currencyFeature = useInput('');
  const partner = useInput('');
  const partnerKeyword = useInput('');
  const [fetchInvoicePartnersLoading, setFetchInvoicePartnersLoading] = useState(false);
  const [invoicePartners, setInvoicePartners] = useState<any[] | InvoicePartner[]>([]);
  const [invoicePartnersPagingData, setInvoicePartnersPagingData] =
    useState<null | InvoicePagingData>(null);
  const hasMoreInvoicePartners =
    invoicePartnersPagingData &&
    invoicePartnersPagingData.page < invoicePartnersPagingData.totalPage;

  const unitListBodyRef = useRef<HTMLDivElement | any>(null);
  const [invoiceList, setInvoiceList] = useState<ProjectInvoice[]>([]);
  const [unPublishedInvoiceList, setUnPublishedInvoiceList] = useState<ProjectInvoice[]>([]);
  const [publishedInvoiceList, setPublishedInvoiceList] = useState<ProjectInvoice[]>([]);

  const setInvoiceListValue = useMemo(() => {
    let projectListValue = [];
    if (projectList?.length) {
      projectListValue = projectList.filter((item: ProjectInvoice) => {
        return !!item.unitList?.length;
      });
    }

    return setInvoiceList(projectListValue);
  }, [projectList]);
  const checkedModifyProject = useCheckSetInput(new Set([]));
  const [newUnitList, setNewUnitList] = useState<Unit[]>([]);
  const [newUnitListLength, setNewUnitListLength] = useState(0);
  const discount = useInput(0);
  const overdue = useInput(0);
  const totalPrice = useMemo(() => {
    const allUnitList = unPublishedInvoiceList.reduce((acc, curr) => {
      return acc.concat(...curr.unitList);
    }, [] as any[]);

    const totalUnitPrice = allUnitList.reduce((acc, curr) => {
      return (acc = acc + curr.unitPrice * curr.quantity);
    }, 0);
    const totalNewUnitPrice = newUnitList.reduce((acc, curr) => {
      return (acc = acc + curr.unitPrice * curr.quantity);
    }, 0);
    return totalUnitPrice + totalNewUnitPrice;
  }, [unPublishedInvoiceList, newUnitList, currency.value]);

  const finalPrice = totalPrice - discount.value + overdue.value;
  const validNewUnitList = useMemo(
    () =>
      !!newUnitList.length ? [...newUnitList].filter(item => validateObjProperties(item)) : [],
    [newUnitList],
  );

  const [completeProjectModalOpen, setCompleteProjectModalOpen] = useState(false);
  const [summaryProjectCode, setSummaryProjectCode] = useState('');
  const handleCloseCompleteProjectModal = () => {
    setCompleteProjectModalOpen(false);
    setIsLoadFailure(false);
    setIsLoadSuccess(false);
    InvoiceActions.fetch_invoice_total_init_request(fetchInvoiceInitParams);
  };
  const handleOpenCompleteProjectModal = (projectCode: string) => {
    setCompleteProjectModalOpen(true);
    setSummaryProjectCode(projectCode);
  };

  const isValidUnitData = useMemo(() => {
    const isValidPeriod = period.value?.length === 2;
    const isValidData = [!!validNewUnitList.length, !!unPublishedInvoiceList.length].some(
      item => item === true,
    );
    return isValidPeriod && isValidData;
  }, [invoiceList.length, validNewUnitList, period.value, unPublishedInvoiceList.length]);

  // SECTION: function

  const handleFetchInvoicePartners = debounce(async (first?: boolean) => {
    if (first) {
      const result = await requestFetchInvoicePartners({ keyword: '', page: 1 });
      setInvoicePartners(result?.list);
      setInvoicePartnersPagingData(result?.pagingData);
      return;
    }

    if (!hasMoreInvoicePartners) return;
    const result = await requestFetchInvoicePartners({
      keyword: partnerKeyword.value?.trim() || '',
      page: invoicePartnersPagingData ? invoicePartnersPagingData?.page + 1 : 1,
    });
    setInvoicePartners(draft => draft.concat(result?.list));
    setInvoicePartnersPagingData(result?.pagingData);
    return;
  }, 500);

  const handleSearchInvoicePartners = debounce(async (value: string) => {
    partnerKeyword.setValue(value);
    setInvoicePartners([]);
    const result = await requestFetchInvoicePartners({ keyword: value?.trim() || '', page: 1 });
    setInvoicePartners(result?.list);
    setInvoicePartnersPagingData(result?.pagingData);
  }, 500);

  const handleRefreshList = () => {
    InvoiceActions.fetch_invoice_total_init_request(fetchInvoiceInitParams);
    setIsLoadSuccess(false);
    setIsLoadFailure(false);
  };

  // TEST:

  useEffect(() => {
    const filterUnPublish = invoiceList.filter(item => {
      return item.currency === currency.value && !item.invoiceInfo?.isExist;
    });
    setUnPublishedInvoiceList(filterUnPublish);

    const filterPublish = invoiceList.filter(item => {
      return item.currency === currency.value && !!item.invoiceInfo?.isExist;
    });
    setPublishedInvoiceList(filterPublish);
  }, [invoiceList, currency.value]);

  // isNew를 통해 invoiceList, newUnitList 구분
  // 새로 만든 projectId 수정, for newUnitList
  const handleChangeUnitProjectId = ({
    id,
    projectId,
    isNew,
  }: {
    id: number;
    projectId: string;
    isNew?: boolean;
  }) => {
    setNewUnitList(draft => {
      return draft.reduce((acc, curr, idx) => {
        return acc.concat(idx === id ? { ...curr, projectId } : curr);
      }, [] as any[]);
    });
  };

  // onChange - content, quzntity, unitPrice value
  // 타입 상수 설정
  const CONTENT = 'content';
  const QUANTITY = 'quantity';
  const UNIT_PRICE = 'unitPrice';
  const handleChangeUnit = ({
    invoiceIdx,
    id,
    isNew,
    type,
    value,
  }: {
    invoiceIdx?: number;
    id: number;
    isNew?: boolean;
    type: string;
    value: string | number;
  }) => {
    if ([QUANTITY, UNIT_PRICE].includes(type) && isNaN(Number(value))) return;

    if (isNew) {
      setNewUnitList(draft => {
        return draft.reduce((acc, curr, idx) => {
          return acc.concat(idx === id ? { ...curr, [type]: value } : curr);
        }, [] as any[]);
      });

      return;
    }

    setInvoiceList(draft => {
      return draft.reduce((acc, curr, idx) => {
        if (idx === invoiceIdx) {
          const parsedUnitList = curr.unitList.reduce((unitAcc, unitCurr, unitIdx) => {
            return unitAcc.concat(unitIdx === id ? { ...unitCurr, [type]: value } : unitCurr);
          }, [] as any[]);

          return acc.concat({ ...curr, unitList: parsedUnitList });
        }
        return acc.concat(curr);
      }, [] as any[]);
    });
  };

  // 기존 invoice data 수정, for InvoiceList
  const handleModifyUnit = ({
    invoiceIdx,
    id,
    isModify,
    isNew,
  }: {
    invoiceIdx: number;
    id: number;
    isModify: boolean | undefined;
    isNew?: boolean;
  }) => {
    setInvoiceList(draft => {
      return draft.reduce((acc, curr, idx) => {
        if (idx === invoiceIdx) {
          const parsedUnitList = curr.unitList.reduce(
            (unitAcc, unitCurr, unitIdx) =>
              unitAcc.concat(
                unitIdx === id ? { ...unitCurr, isModify: !unitCurr.isModify } : unitCurr,
              ),
            [] as any[],
          );

          return acc.concat({ ...curr, unitList: parsedUnitList });
        }
        return acc.concat(curr);
      }, [] as any[]);
    });

    // when modify, focus input
    if (!isModify) {
      unitListBodyRef.current
        .querySelector(`[data-id="${id}"] .createInvoiceModal__receipt_input.content`)
        .focus();
    }
  };

  const handleRemoveInvoice = (pCode: string) => {
    const invoiceListTemp: any[] = invoiceList.filter((item: any) => {
      return item.projectCode !== pCode;
    });
    setInvoiceList([...invoiceListTemp]);
    const invoiceListTemp2: any[] = unPublishedInvoiceList.filter((item: any) => {
      return item.projectCode !== pCode;
    });
    setUnPublishedInvoiceList([...invoiceListTemp2]);
  };

  const handleRemoveUnit = ({
    invoiceIdx,
    id,
    isNew,
  }: {
    invoiceIdx?: number;
    id: number;
    isNew?: boolean;
  }) => {
    if (isNew) {
      setNewUnitList(draft => {
        return draft.filter((item, idx) => idx !== id);
      });

      return;
    }
    setInvoiceList(draft => {
      const currentInvoice: ProjectInvoice | any =
        draft.find((item, idx) => idx === invoiceIdx) || [];
      if (currentInvoice.unitList.length === 1) {
        return draft.filter((item, idx) => idx !== invoiceIdx);
      } else {
        return draft.reduce((acc, curr, idx) => {
          if (idx === invoiceIdx) {
            const parsedUnitList = curr.unitList.filter((unitItem, unitIdx) => {
              return unitIdx !== id;
            });

            return acc.concat({ ...curr, unitList: parsedUnitList });
          }
          return acc.concat(curr);
        }, [] as any[]);
      }
    });
  };

  const handleAddUnit = () => {
    const unitDefaultForm = {
      content: '',
      quantity: 0,
      unitPrice: 0,
    };
    setNewUnitList((draft: any) => [...draft, unitDefaultForm]);
  };

  const handlePublishProject = () => {
    if (!isValidUnitData) return;
    let newUnitObj = {};
    let unPublishedInvoiceListArray: any[] = [];
    if (newUnitList.length > 0) {
      newUnitObj = {
        projectIdx: null,
        projectId: null,
        unitList: newUnitList,
      };
      unPublishedInvoiceListArray = [newUnitObj, ...unPublishedInvoiceList];
    } else {
      unPublishedInvoiceListArray = [...unPublishedInvoiceList];
    }
    const submitData = {
      partnerGroupIdx: partner.value || '',
      partnerName: partnerInfo?.partnerName,
      accountEmail: partnerInfo?.partnerEmail,
      currency: partnerInfo?.currencyCode,
      discount: discount.value === 0 ? 0 : -Math.abs(discount.value),
      overdue: overdue.value,
      startDate: period.value ? period.value[0].format('YYYY-MM-DD') : '',
      endDate: period.value ? period.value[1].format('YYYY-MM-DD') : '',
      invoiceProjectList: unPublishedInvoiceListArray.filter(item => !!item.unitList.length),
    };
    InvoiceActions.create_invoice_request(submitData);
  };
  // init invoiceProjectList data
  useEffect(() => {
    handleFetchInvoicePartners(true);
  }, []);

  useEffect(() => {
    currencyFeature.setValue(
      currencyList?.find((i: ICurrency) => i.code === currency.value)?.feature,
    );
  }, [currency.value]);

  useDidUpdateEffect(() => {
    if (invoiceInitDataSuccess && projectList.length > 0) {
      currency.setValue(partnerInfo.currencyCode);
    }
  }, [invoiceInitDataSuccess]);

  useDidUpdateEffect(() => {
    if (invoiceInitDataSuccess) {
      setIsLoadSuccess(true);
    }
  }, [invoiceInitDataSuccess]);

  useDidUpdateEffect(() => {
    if (!invoiceInitDataFailure) return;
    setIsLoadFailure(true);
  }, [invoiceInitDataFailure]);

  // SECTION: DidUpdate
  // when newUnitList.length change, compare prevLength with currentLength
  useDidUpdateEffect(() => {
    // if add, scroll and focus
    if (unitListBodyRef.current) {
      unitListBodyRef.current.scrollTop = unitListBodyRef.current.scrollHeight;

      const isBigger = newUnitList.length > newUnitListLength;
      const inputRowElementList = unitListBodyRef.current.querySelectorAll(`[data-new-id]`);
      if (inputRowElementList.length && isBigger) {
        const lastElement = inputRowElementList[inputRowElementList.length - 1];
        lastElement.querySelector(`.createInvoiceModal__receipt_input.content`).focus();
      }
    }
    setNewUnitListLength(newUnitList.length);
  }, [newUnitList.length]);

  const fetchInvoiceInitParams = useMemo(
    () => ({
      startDate: period.value ? period.value[0].format('YYYY-MM-DD') : '',
      endDate: period.value ? period.value[1].format('YYYY-MM-DD') : '',
      partnerGroupIdx: partner.value || '',
    }),
    [partner.value, period.value],
  );

  // SECTION: DidMount
  useEffect(() => {
    // DidUnMount
    // invoiceInit clear
    return () => {
      InvoiceActions.fetch_invoice_total_init_clear();
      setIsLoadFailure(false);
      setIsLoadSuccess(false);
    };
  }, []);

  // request api when partner, period change
  useDidUpdateEffect(() => {
    if (!partner.value || !(period.value?.length === 2)) {
      setIsLoadFailure(false);
      setIsLoadSuccess(false);
      return InvoiceActions.fetch_invoice_total_init_clear();
    }
    InvoiceActions.fetch_invoice_total_init_request(fetchInvoiceInitParams);
  }, [partner.value, period.value]);

  // when createInvoiceSuccess
  useDidUpdateEffect(() => {
    if (createInvoiceSuccess) {
      onClose();
      InvoiceActions.fetch_invoices_request({
        page: 1,
        partnerGroupIdx: '',
        startDate: '',
        endDate: '',
        keyword: '',
      });
    }
  }, [createInvoiceSuccess]);

  return (
    <StyledCreateInvoiceModalContainer data-component-name="CreateInvoiceModalContainer">
      {useMemo(
        () => (
          <PlainModal isOpen={completeProjectModalOpen} width={1280}>
            <AppModal
              title={t('COMPLETE_PROJECT')}
              content={
                <CompleteProjectModalContainer
                  projectCode={summaryProjectCode}
                  isModifyFlag={true}
                  onCancel={handleCloseCompleteProjectModal}
                />
              }
              contentCardStyle={{
                borderRadius: '8px',
                marginBottom: '28px',
                padding: '38px 30px 76px',
              }}
              isCloseIcon={true}
              onCancel={handleCloseCompleteProjectModal}
              hideButton={true}
            />
          </PlainModal>
        ),
        [completeProjectModalOpen, summaryProjectCode],
      )}
      <div className="createInvoiceModal__top">
        <div className="createInvoiceModal__filter_container">
          <div className="createInvoiceModal__filter_label">
            <T>CREATE_INVOICE_SELECT_PARTNER</T>
          </div>
          <div className="createInvoiceModal__filter_box">
            <AsyncFetchSelect
              className="sm createInvoiceModal__partner_select_box"
              inputProps={{
                placeholder: t('PARTNER_LIST'),
                selectedValue: partner.value,
                setSelectedValue: partner.setValue,
                data: invoicePartners,
                hasMoreData: hasMoreInvoicePartners,
                idKey: 'userGroupIdx',
                labelKey: 'name',
                onFetch: handleFetchInvoicePartners,
                searchLoading: fetchInvoicePartnersLoading,
                onSearch: handleSearchInvoicePartners,
              }}
            />

            <CustomDatePicker
              type="rangeDate"
              fullWidth
              borderColor="#B5B7C1"
              height={32}
              fontSize={12}
              value={period.value}
              onChange={period.onChange}
              className={cx({
                error: period.value !== null ? !period.value : false,
              })}
              isClient={true}
            />

            {invoiceCurrencyList?.length > 0 && (
              <MuiWrapper className="createInvoiceModal__invoice_currency_wrapper">
                <FormControl fullWidth variant="outlined">
                  <StyledGlobalCurrencySelect />
                  <Select
                    MenuProps={{
                      anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left',
                      },

                      getContentAnchorEl: null,
                    }}
                    name="currency"
                    value={currency.value}
                    onChange={currency.onChange}
                  >
                    {invoiceCurrencyList?.map((value: any, index: number) => {
                      const currecyData = currencyList?.find((i: ICurrency) => i.code === value);

                      return (
                        <MenuItem
                          value={value}
                          key={index}
                          className={cx('createInvoiceModal__currency_select_item_container', {
                            selected: currency.value === value ? true : false,
                          })}
                        >
                          <div
                            className={cx('createInvoiceModal__currency_select_item_box', {
                              selected: currency.value === value ? true : false,
                            })}
                          >
                            <div>
                              {currecyData.feature} {currecyData.name}
                            </div>
                          </div>
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </MuiWrapper>
            )}
          </div>
        </div>
      </div>

      <div className="createInvoiceModal__middle">
        <div className="createInvoiceModal__receipt_container">
          <div className="createInvoiceModal__receipt_info_box">
            <div className="createInvoiceModal__receipt_info_card">
              <div className="createInvoiceModal__receipt_info_card_partner">
                <div className="createInvoiceModal__receipt_info_card_partner_to flex-center">
                  <T>GLOBAL_INVOICE_TO</T>
                </div>
                <CustomText
                  className="completeProjectModal__receipt_info_card_partner_name"
                  fontSize={21}
                  fontWeight={700}
                  marginTop={25}
                >
                  {partnerInfo?.partnerName}
                </CustomText>
              </div>
              <div className="createInvoiceModal__receipt_info_card_date_box">
                <CustomText fontColor={color.gray_week}>
                  <T>GLOBAL_PERIOD</T>
                </CustomText>
                {period.value && (
                  <div className="createInvoiceModal__receipt_info_card_date">
                    {language === 'en' ? (
                      <>
                        <p>{moment(period.value[0]).locale(language).format('MMM DD, YYYY')} ~</p>
                        <p>{moment(period.value[1]).locale(language).format('MMM DD, YYYY')}</p>
                      </>
                    ) : (
                      <>
                        <p>
                          {moment(period.value[0]).locale(language).format('YYYY/MM/DD')}
                          {' ~'}
                        </p>
                        <p>{moment(period.value[1]).locale(language).format('YYYY/MM/DD')}</p>
                      </>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="createInvoiceModal__receipt_items_box">
            <div className="createInvoiceModal__receipt_items_table">
              <div className="createInvoiceModal__receipt_items_thead">
                <div className="createInvoiceModal__receipt_items_row">
                  <div className="createInvoiceModal__receipt_items_th">
                    <T>PROJECT_ID</T>
                  </div>
                  <div className="createInvoiceModal__receipt_items_th">
                    <T>GLOBAL_CONTENT</T>
                  </div>
                  <div className="createInvoiceModal__receipt_items_th">
                    <T>GLOBAL_QUANTITY</T>
                  </div>
                  <div className="createInvoiceModal__receipt_items_th">
                    <T>GLOBAL_UNIT_PRICE</T>
                  </div>
                  <div className="createInvoiceModal__receipt_items_th">
                    <T>GLOBAL_PRICE</T>
                  </div>
                  <div className="createInvoiceModal__receipt_items_th"></div>
                </div>
              </div>

              <Grid
                container
                className="createInvoiceModal__receipt_items_tbody"
                ref={unitListBodyRef}
              >
                {invoiceList?.length < 1 && invoiceInitDataPending && (
                  <div className="infinite-scroll-loading">
                    <CircularLoading />
                  </div>
                )}
                {!!isLoadSuccess &&
                  (invoiceList.length > 0 ? (
                    invoiceList.map((invoiceItem: ProjectInvoice, invoiceIdx: number) => {
                      if (invoiceItem.currency != currency.value) return;
                      return (
                        <div
                          key={invoiceItem.projectIdx}
                          className={cx('createInvoiceModal__receipt_items_row_box', {
                            isExist: !!invoiceItem.invoiceInfo.isExist,
                          })}
                        >
                          <div className="createInvoiceModal__receipt_items_row">
                            <div className="createInvoiceModal__receipt_items_td project_id">
                              <span
                                className={cx('createInvoiceModal__receipt_items_pid', {
                                  isAbledModify: !invoiceItem.invoiceInfo.isExist,
                                })}
                                onClick={() => {
                                  if (!!invoiceItem.invoiceInfo.isExist) return;
                                  handleOpenCompleteProjectModal(invoiceItem.projectCode);
                                }}
                              >
                                {invoiceItem.projectId}{' '}
                                {!invoiceItem.invoiceInfo.isExist && (
                                  <img
                                    className="createInvoiceModal__receipt_items_pid_modify"
                                    src={icon_modify}
                                  />
                                )}
                              </span>
                              {!invoiceItem.invoiceInfo.isExist && (
                                <div>
                                  <IconButton
                                    aria-label="cancel modal"
                                    onClick={() => {
                                      handleRemoveInvoice(invoiceItem.projectCode);
                                    }}
                                  >
                                    <TrashIcon />
                                  </IconButton>
                                </div>
                              )}
                            </div>
                          </div>
                          {!!invoiceItem.unitList.length &&
                            invoiceItem.unitList.map((unitItem, unitIdx) => {
                              const isModifyUnitItem = [...checkedModifyProject.value].find(
                                item => item === `${invoiceIdx}-${unitIdx}`,
                              );
                              return (
                                <Grid
                                  item
                                  container
                                  className="createInvoiceModal__receipt_items_row"
                                  data-id={unitIdx}
                                  key={unitIdx}
                                >
                                  <Grid
                                    item
                                    container
                                    alignItems="center"
                                    className="createInvoiceModal__receipt_items_td"
                                  ></Grid>
                                  <Grid
                                    item
                                    container
                                    alignItems="center"
                                    className="createInvoiceModal__receipt_items_td"
                                  >
                                    <div className="createInvoiceModal__receipt_input content">
                                      {unitItem.content || ''}
                                    </div>
                                  </Grid>
                                  <Grid
                                    item
                                    container
                                    alignItems="center"
                                    justifyContent="center"
                                    className="createInvoiceModal__receipt_items_td"
                                  >
                                    <input
                                      type="text"
                                      readOnly={!isModifyUnitItem}
                                      placeholder="0"
                                      value={unitItem.quantity || ''}
                                      maxLength={11}
                                      onChange={e =>
                                        handleChangeUnit({
                                          invoiceIdx,
                                          id: unitIdx,
                                          type: QUANTITY,
                                          value: Number(e.target.value.replace(/,/g, '')),
                                        })
                                      }
                                      className="createInvoiceModal__receipt_input quantity"
                                    />
                                  </Grid>
                                  <Grid
                                    item
                                    container
                                    alignItems="center"
                                    justifyContent="flex-end"
                                    className="createInvoiceModal__receipt_items_td"
                                  >
                                    <input
                                      type="text"
                                      readOnly={!isModifyUnitItem}
                                      placeholder="0"
                                      value={
                                        unitItem.unitPrice ? addCommas(unitItem.unitPrice) : ''
                                      }
                                      maxLength={11}
                                      onChange={e =>
                                        handleChangeUnit({
                                          invoiceIdx,
                                          id: unitIdx,
                                          type: UNIT_PRICE,
                                          value: Number(e.target.value.replace(/,/g, '')),
                                        })
                                      }
                                      className="createInvoiceModal__receipt_input price"
                                    />
                                  </Grid>
                                  <Grid
                                    item
                                    container
                                    alignItems="center"
                                    justifyContent="flex-end"
                                    className="createInvoiceModal__receipt_items_td"
                                  >
                                    {currencyFeature.value}{' '}
                                    {addCommas(unitItem.unitPrice * unitItem.quantity)}
                                  </Grid>
                                  <Grid
                                    item
                                    container
                                    alignItems="center"
                                    className="createInvoiceModal__receipt_items_td"
                                  ></Grid>
                                </Grid>
                              );
                            })}
                        </div>
                      );
                    })
                  ) : (
                    <ListEmpty text="GLOBAL_EMPTY_LIST_DATA" />
                  ))}
                {!!isLoadFailure && (
                  <ListEmpty
                    text="GLOBAL_LIST_ERROR"
                    isRefreshButton={true}
                    onRefresh={handleRefreshList}
                  />
                )}
                {!!newUnitList.length &&
                  newUnitList.map((item: Unit, idx) => (
                    <Grid
                      item
                      container
                      className="createInvoiceModal__receipt_items_row"
                      data-new-id={`new-${idx}`}
                      key={idx}
                    >
                      <Grid
                        item
                        container
                        alignItems="center"
                        className="createInvoiceModal__receipt_items_td new"
                      >
                        <div className="createInvoiceModal__receipt_input_wrapper">
                          <textarea
                            className="createInvoiceModal__receipt_input content new"
                            placeholder=""
                            value={item.content || ''}
                            onKeyDown={e => {
                              if (e.code === 'Enter') e.preventDefault();
                            }}
                            onChange={e => {
                              if (e.target.value.length > 200) return;
                              handleChangeUnit({
                                id: idx,
                                isNew: true,
                                type: CONTENT,
                                value: e.target.value,
                              });
                            }}
                          ></textarea>
                        </div>
                      </Grid>
                      <Grid
                        item
                        container
                        alignItems="center"
                        justifyContent="center"
                        className="createInvoiceModal__receipt_items_td new"
                      >
                        <input
                          type="text"
                          placeholder="0"
                          value={item.quantity || ''}
                          onChange={e => {
                            if (e.target.value.length > 3) return;
                            handleChangeUnit({
                              id: idx,
                              isNew: true,
                              type: QUANTITY,
                              value: Number(e.target.value.replace(/,/g, '')),
                            });
                          }}
                          className="createInvoiceModal__receipt_input quantity"
                        />
                      </Grid>
                      <Grid
                        item
                        container
                        alignItems="center"
                        justifyContent="flex-end"
                        className="createInvoiceModal__receipt_items_td new"
                      >
                        <input
                          type="text"
                          placeholder="0"
                          value={item.unitPrice ? addCommas(item.unitPrice) : ''}
                          maxLength={11}
                          onChange={e => {
                            if (e.target.value.length > 12) return;
                            handleChangeUnit({
                              id: idx,
                              isNew: true,
                              type: UNIT_PRICE,
                              value: Number(e.target.value.replace(/,/g, '')),
                            });
                          }}
                          className="createInvoiceModal__receipt_input price"
                        />
                      </Grid>
                      <Grid
                        item
                        container
                        alignItems="center"
                        justifyContent="flex-end"
                        className="createInvoiceModal__receipt_items_td new"
                      >
                        {currencyFeature.value} {addCommas(item.unitPrice * item.quantity)}
                      </Grid>
                      <Grid
                        item
                        container
                        alignItems="center"
                        justifyContent="flex-end"
                        className="createInvoiceModal__receipt_items_td new"
                      >
                        <IconButton
                          aria-label="cancel modal"
                          onClick={() => handleRemoveUnit({ id: idx, isNew: true })}
                        >
                          <TrashIcon />
                        </IconButton>
                      </Grid>
                    </Grid>
                  ))}
                {unPublishedInvoiceList.length > 0 && (
                  <div className="createInvoiceModal__receipt_items_plus_icon_container">
                    <button
                      className="createInvoiceModal__receipt_items_plus_icon_box btn-reset inline-flex-center"
                      onClick={e => {
                        e.stopPropagation();
                        handleAddUnit();
                      }}
                    >
                      <AddIcon
                        htmlColor="white"
                        fontSize="inherit"
                        className="createInvoiceModal__receipt_items_plus_icon"
                      />
                    </button>
                    <CustomSpan fontColor="#b5b7c1" marginLeft={10}>
                      <T>ADD_CONTENT</T>
                    </CustomSpan>
                  </div>
                )}
              </Grid>

              <Grid
                container
                alignItems="center"
                justifyContent="flex-end"
                className="createInvoiceModal__receipt_total_price"
              >
                {currencyFeature.value} {addCommas(totalPrice)}
              </Grid>

              <Grid
                container
                justifyContent="flex-end"
                className="createInvoiceModal__receipt_etc_row"
              >
                <Grid
                  container
                  alignItems="center"
                  justifyContent="space-between"
                  className="createInvoiceModal__receipt_etc_td"
                >
                  <CustomSpan fontColor={color.blue}>
                    <T>GLOBAL_DISCOUNT</T>
                  </CustomSpan>
                  <div className="inline-flex-center">
                    <RemoveIcon htmlColor={color.gray_week} fontSize="small" />
                    <input
                      type="text"
                      placeholder="0"
                      maxLength={11}
                      value={discount.value ? addCommas(discount.value) : ''}
                      onChange={e => {
                        const targetValue = Number(e.target.value.replace(/,/g, ''));
                        if (isNaN(targetValue)) return;
                        discount.onChange({ value: targetValue });
                      }}
                      className="createInvoiceModal__receipt_input etc"
                    />
                  </div>
                </Grid>
              </Grid>

              <Grid
                container
                justifyContent="flex-end"
                className="createInvoiceModal__receipt_etc_row"
              >
                <Grid
                  container
                  alignItems="center"
                  justifyContent="space-between"
                  className="createInvoiceModal__receipt_etc_td"
                >
                  <CustomSpan fontColor={color.blue}>
                    <T>GLOBAL_OVERDUE</T>
                  </CustomSpan>
                  <div className="inline-flex-center">
                    <AddIcon htmlColor={color.gray_week} fontSize="small" />
                    <input
                      type="text"
                      placeholder="0"
                      maxLength={11}
                      value={overdue.value ? addCommas(overdue.value) : ''}
                      onChange={e => {
                        const targetValue = Number(e.target.value.replace(/,/g, ''));
                        if (isNaN(targetValue)) return;
                        overdue.onChange({ value: targetValue });
                      }}
                      className="createInvoiceModal__receipt_input etc"
                    />
                  </div>
                </Grid>
              </Grid>

              <Grid
                container
                alignItems="center"
                justifyContent="flex-end"
                className="createInvoiceModal__receipt_final_price"
              >
                <CustomSpan fontSize={18} fontWeight={500} marginRight={100}>
                  <T>GLOBAL_TOTAL</T>
                </CustomSpan>
                <CustomSpan fontSize={21} fontWeight={700}>
                  {currencyFeature.value} {addCommas(finalPrice)}
                </CustomSpan>
              </Grid>
            </div>
          </div>
        </div>
      </div>

      <StyledPlainButtonOuter backgroundColor={color.navy_blue} height={76} left={'50%'}>
        <MuiButton
          config={{
            width: '320px',
          }}
          disabled={!isValidUnitData}
          disableElevation
          variant="contained"
          onClick={handlePublishProject}
          className="xl border-radius-round inset-shadow-default projectInformation__next_btn"
        >
          {finalPrice ? (
            <>
              {' '}
              <T>GLOBAL_PUBLISH</T> l {currencyFeature.value} {addCommas(finalPrice)}
            </>
          ) : (
            <T>GLOBAL_PUBLISH</T>
          )}
        </MuiButton>
      </StyledPlainButtonOuter>
    </StyledCreateInvoiceModalContainer>
  );
}

const StyledGlobalCurrencySelect = createGlobalStyle<{}>`

.createInvoiceModal__currency_select_item_container {
  &.selected {
    background-color: #00A6E2 !important;
  }
  .createInvoiceModal__currency_select_item_box {
  
    width: 100%;
    padding-right: 20px;
    display: flex;
    justify-content: space-between;
    font-weight: 400;
    color: #303030;
    &.selected {
      color: #ffffff;
    }
    
  }
}
`;

const StyledCreateInvoiceModalContainer = styled.div`
  .createInvoiceModal__top {
    .createInvoiceModal__filter_container {
      display: flex;
      align-items: center;
      column-gap: 30px;
      justify-content: space-between;

      .createInvoiceModal__filter_label {
        width: 330px;
        font-size: 19px;
        font-weight: 700;
      }

      .createInvoiceModal__filter_box {
        display: flex;
        flex-wrap: wrap;
        width: 700px;

        .createInvoiceModal__partner_select_box {
          width: 250px;
        }

        .datePicker__box {
          margin-left: 15px;
          width: 225px;
        }

        .createInvoiceModal__invoice_currency_wrapper {
          margin-left: 15px;
          width: 190px;
          height: 32px;
          .createInvoiceModal__currency_select_item_box {
            width: 100%;
            padding-right: 4px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-weight: 400;
            &.selected {
              color: #303030;
            }
          }
        }
      }
    }
  }

  .createInvoiceModal__middle {
    margin-top: 40px;
    margin-bottom: 20px;

    .createInvoiceModal__receipt_container {
      display: flex;
      column-gap: 30px;

      .createInvoiceModal__receipt_info_box {
        width: 240px;
        .createInvoiceModal__receipt_info_card {
          height: 100%;
          padding: 0 30px;
          background-color: ${color.navy_blue};
          border-radius: 10px;
          color: white;

          .createInvoiceModal__receipt_info_card_partner {
            padding: 30px 0;
            border-bottom: 3px solid white;
            min-height: 126px;
            .createInvoiceModal__receipt_info_card_partner_to {
              width: 120px;
              height: 30px;
              border-radius: 15px;
              border: 1px solid white;
              font-size: 13px;
            }
            .completeProjectModal__receipt_info_card_partner_name {
              text-overflow: ellipsis;
              word-break: break-all;
            }
          }

          .createInvoiceModal__receipt_info_card_date_box {
            padding: 25px 0;
            .createInvoiceModal__receipt_info_card_date {
              margin-top: 15px;
              p {
                font-size: 19px;
                font-weight: 500;
              }
            }
          }
          .createInvoiceModal__receipt_info_card_email {
          }
        }
      }

      .createInvoiceModal__receipt_items_box {
        width: 930px;
        .createInvoiceModal__receipt_items_table {
          .createInvoiceModal__receipt_items_th,
          .createInvoiceModal__receipt_items_td {
            position: relative;
            min-height: 50px;
            white-space: nowrap;
            flex-wrap: nowrap;
            line-height: 1;

            &:nth-child(1) {
              width: 260px;
              justify-content: flex-start;
              &.project_id {
                display: flex;
                align-items: center;
                width: 930px;
                padding-right: 20px;
                justify-content: space-between;
                .createInvoiceModal__receipt_items_pid {
                  &.isAbledModify {
                    &:hover {
                      text-decoration: underline;
                      font-size: 13px;
                      font-weight: 500;
                    }
                  }
                  .createInvoiceModal__receipt_items_pid_modify {
                    margin-left: 10px;
                  }
                }
              }
            }
            &:nth-child(2) {
              width: 280px;
              justify-content: flex-start;
            }
            &:nth-child(3) {
              width: 90px;
              justify-content: flex-start;
            }
            &:nth-child(4) {
              width: 120px;
              justify-content: flex-start;
            }
            &:nth-child(5) {
              width: 120px;
              justify-content: flex-end;
            }
            &:nth-child(6) {
              justify-content: flex-start;
              width: 60px;
            }

            &.new:nth-child(1) {
              width: 540px;
              justify-content: flex-start;
            }
            &.new:nth-child(2) {
              width: 90px;
              justify-content: flex-start;
            }
            &.new:nth-child(3) {
              width: 120px;
              justify-content: flex-start;
            }
            &.new:nth-child(4) {
              width: 120px;
              justify-content: flex-end;
            }
            &.new:nth-child(5) {
              width: 60px;
              justify-content: flex-start;
            }
          }
        }
        .createInvoiceModal__receipt_items_row_box {
          &.isExist {
            text-decoration: line-through;
          }
        }

        .createInvoiceModal__receipt_items_td {
          font-size: 13px;
        }
        .createInvoiceModal__receipt_items_row {
          display: flex;
          align-items: center;
          min-height: 50px;
          .createInvoiceModal__receipt_items_td {
            display: flex;
            align-items: center;
          }
        }
        .createInvoiceModal__receipt_items_thead {
          border-top: 3px solid #edf4fb;
          border-bottom: 3px solid #edf4fb;
          .createInvoiceModal__receipt_items_row {
            display: flex;
            height: 50px;
            div {
              align-items: center;
              display: flex;
            }
          }
        }
        .createInvoiceModal__receipt_items_tbody {
          position: relative;
          width: 100%;
          height: 357px;
          overflow-y: overlay;
          .createInvoiceModal__receipt_items_row {
            border-bottom: 1px solid #edf4fb;
          }
        }

        .createInvoiceModal__receipt_input_wrapper {
          min-height: 70px;
          width: 100%;
          display: flex;
          align-items: center;
          textarea {
            resize: none;
            width: 95%;
            height: 60px;
          }
        }

        .createInvoiceModal__receipt_items_plus_icon_container {
          height: 50px;
          display: flex;
          align-items: center;
        }
        .createInvoiceModal__receipt_items_plus_icon_box {
          margin-right: 5px;
          width: 20px;
          height: 20px;
          background-color: ${color.blue};
          border-radius: 50%;
          font-size: 18px;
        }
        .createInvoiceModal__receipt_input {
          width: 100%;
          padding: 5px;
          border: 1px solid transparent;
          font-size: 13px;

          &:read-only {
          }
          &:not(:read-only) {
            border-color: ${color.gray_week};
            border-radius: 5px;
          }
          &.project_id {
            width: 85%;
          }
          &.content {
            width: 95%;
            display: flex;
            align-items: center;
            word-break: break-all;
            white-space: pre-line;
            &.new {
              width: 90%;
            }
          }
          &.quantity {
            width: 90%;
            text-align: left;
          }
          &.price {
            width: 90%;
            text-align: left;
          }
          &.etc {
            margin-left: 5px;
            width: 150px;
            text-align: right;
          }
        }

        .createInvoiceModal__receipt_total_price {
          margin-bottom: 15px;
          min-height: 50px;
          font-size: 19px;
          font-weight: 700;
          padding-right: 60px;
          text-align: right;
        }
        .createInvoiceModal__receipt_etc_row {
          .createInvoiceModal__receipt_etc_td {
            position: relative;
            width: 386px;
            min-height: 50px;
            border-top: 1px solid #edf4fb;
            padding-left: 15px;
            padding-right: 60px;
          }
        }
        .createInvoiceModal__receipt_final_price {
          min-height: 50px;
          padding-right: 60px;
          border-top: 3px solid #edf4fb;
        }
      }
    }
  }

  .createInvoiceModal__currency_select_item_box {
    width: 100%;
    padding-right: 4px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 400;
    &.selected {
      color: #303030;
    }
  }
`;

export default React.memo(CreateInvoiceModalContainer);
